import { render, staticRenderFns } from "./AuthBanner.vue?vue&type=template&id=e1470c18&scoped=true"
import script from "./AuthBanner.vue?vue&type=script&lang=js"
export * from "./AuthBanner.vue?vue&type=script&lang=js"
import style0 from "./AuthBanner.vue?vue&type=style&index=0&id=e1470c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1470c18",
  null
  
)

export default component.exports